<template>
    <!-- <div class="mb-4"> -->
      <CCol lg="8" sm="12" class="mb-3">
      <div class="form-group">
          <date-range-picker
            ref="picker"
            class="w-100"
            :opens="opens"
            :locale-data="{ firstDay: 1, format: 'yyyy-mm-dd HH:MM:ss' }"
            :minDate="minDate"
            :maxDate="maxDate"
            :singleDatePicker="singleDatePicker"
            :timePicker="timePicker"
            :timePicker24Hour="timePicker24Hour"
            :showWeekNumbers="showWeekNumbers"
            :showDropdowns="showDropdowns"
            :autoApply="autoApply"
            v-model="dateRange"
            :ranges="show_ranges ? undefined : false"
            @update="updateValues"
            @toggle="checkOpen"
            :linkedCalendars="linkedCalendars"
            :dateFormat="dateFormat"
            :always-show-calendars="false"
            :alwaysShowCalendars="alwaysShowCalendars"
            placeholder="Pilih Tanggal Untuk Melakukan Filter Data"
          >
            <div
              slot="input"
              slot-scope="picker"
              class="ml-4"
              style="min-width: 630px"
            >
              {{ picker.startDate | date }} - {{ picker.endDate | date }}
            </div>
          </date-range-picker>
        </div>
      </CCol>
    <!-- </div> -->
</template>

<script>
  import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually (in case you want to override it)
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import moment from 'moment'
  export default {
    components: {DateRangePicker},
    name: 'DateRangePickerDemo',
    filters: {
      date (value) {
        if (!value)
          return ''
        let options = {year: 'numeric', month: 'long', day: 'numeric'};
        return Intl.DateTimeFormat('en-US', options).format(value)
      }
    },
    data () {
      //                    :locale-data="{ daysOfWeek: [ 'Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб' ] }"
      return {
        opens: 'center',
        minDate: '2019-05-02 04:00:00',
        maxDate: '2020-12-26 14:00:00',
        // minDate: '',
        // maxDate: '',
        dateRange: {
          startDate: '2019-12-10',
          endDate: '2019-12-20',
        },
        show_ranges: true,
        singleDatePicker: false,
        timePicker: true,
        timePicker24Hour: true,
        showDropdowns: true,
        autoApply: false,
        showWeekNumbers: true,
        linkedCalendars: true,
        alwaysShowCalendars: true,
      }
    },
    mounted () {
      // this.$refs.picker.open = true
    },
    methods: {
      updateValues (values) {
        this.dateRange.startDate = moment(values.startDate).format('YYYY-MM-DD HH:mm:ss');
        this.dateRange.endDate = moment(values.endDate).format('YYYY-MM-DD HH:mm:ss');
      },
      checkOpen (open) {
      },
      dateFormat (classes, date) {
        let yesterday = moment().subtract(1, 'day');
        if (!classes.disabled) {
          classes.disabled = moment(date).isSame(yesterday, 'day')
        }
        return classes
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  h1, h2 {
    font-weight: normal;
  }
  a {
    color: #42b983;
  }
  small.form-text {
    display: initial;
    &::before {
      content: ' - ';
    }
  }
</style>